import {
  useGetShiftRotationQuery,
  useShiftRotationCreationMutation,
} from "AppQuries/shift/schedule/rotation";
import ShiftRotationModal from "Components/Modal/shiftRotation";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from "date-fns";
import Error404 from "MainPages/ErrorPages/error404";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, PlusCircle } from "react-feather";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { message, Table } from "antd";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { yupResolver } from "@hookform/resolvers/yup";
import { shiftRotationValidationSchema } from "core/Operations/ValidationSchema/shiftValidation";
import dayjs from "dayjs";
import { toast } from "core/Operations/toast";

import { useGetAllShiftPoliciesQuery } from "AppQuries/shift/policy/shift-policy";
import { useGetGroupsQuery } from "AppQuries/master/Group/group";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const ShiftRotation = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError: isGettingError,
    error: gettingError,
    refetch: getShiftRotationData,
  } = useGetShiftRotationQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    employeeCode: 0,
    fromDate: format(startOfMonth(new Date(), 1), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date(), 1), "yyyy-MM-dd"),
  });
  const shiftRotationData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        ...d,
        id: _id + 1,
      }))
    : [];
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
    },
    resolver: yupResolver(shiftRotationValidationSchema),
  });
  const {
    mutate: shiftRotate,
    isError,
    error,
  } = useShiftRotationCreationMutation();

  const { data: groups } = useGetGroupsQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isTrue: true,
  });

  const { data: shift } = useGetAllShiftPoliciesQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    isTrue: true,
  });

  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const handleClose = () => setShow(false);
  const handleAddClick = () => {
    setSelectedItem(null);
    methods.reset({
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      scheduleFromDate: format(new Date(), "yyyy-MM-dd"),
      scheduleToDate: format(dayjs(new Date()).add(6, "day"), "yyyy-MM-dd"),
      isActive: true,
      createUser: userData.userName,
      remarks: "",
      approvedBy: userData.userName,
      shiftRotation: [
        {
          group: "",
          shift: "",
        },
      ],
    });
    setShow(true);
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    console.log(item);
    methods.reset({
      companyCode: item.companyCode,
      locationCode: item.locationCode,
      scheduleFromDate: format(new Date(item.rotationFromDate), "yyyy-MM-dd"),
      scheduleToDate: format(new Date(item.rotationToDate), "yyyy-MM-dd"),
      isActive: item.isActive,
      createUser: item.createUser,
      remarks: item.remarks,
      approvedBy: item.approvedBy,
      shiftRotation: [{ group: item.groupCode, shift: item.shiftID }],
    });
    setShow(true);
  };

  const onSubmit = (data) => {
    const payload = data?.shiftRotation?.map((d) => ({
      companyCode: data.companyCode,
      employeeCode: "",
      locationCode: data.locationCode,
      groupCode: d?.group,
      shiftID: d?.shift,
      scheduleFromDate: `${format(
        new Date(data?.scheduleFromDate),
        "yyyy-MM-dd"
      )}T${format(new Date(), "HH:mm:ss.SSS")}Z`,
      scheduleToDate: `${format(
        new Date(data?.scheduleToDate),
        "yyyy-MM-dd"
      )}T${format(new Date(), "HH:mm:ss.SSS")}Z`,
      createUser: data.createUser,
      remarks: data.remarks,
      approvedBy: data.approvedBy,
      isActive: data.isActive,
    }));

    shiftRotate(payload, {
      onSuccess: (data) => {
        if (data?.[0]?.response === true) {
          toast.success(
            data?.[0]?.errorMessage || "Shift rotation saved Successfully."
          );
          handleClose();
          getShiftRotationData();
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.length - b.id.length,
    },
    {
      title: "Rotation From Date",
      dataIndex: "rotationFromDate",
      sorter: (a, b) => a.rotationFromDate.length - b.rotationFromDate.length,
      render: (text, record) => <>{format(new Date(text), "dd-MM-yyyy")}</>,
    },
    {
      title: "Rotation To Date",
      dataIndex: "rotationToDate",
      sorter: (a, b) => a.rotationToDate.length - b.rotationToDate.length,
      render: (text, record) => <>{format(new Date(text), "dd-MM-yyyy")}</>,
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      sorter: (a, b) => a.groupName.length - b.groupName.length,
    },
    {
      title: "Shift Name",
      dataIndex: "shiftName",
      sorter: (a, b) => a.shiftName.length - b.shiftName.length,
    },
    {
      title: "Approved By",
      dataIndex: "approvedBy",
      sorter: (a, b) => a.approvedBy.length - b.approvedBy.length,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      sorter: (a, b) => a.remarks.length - b.remarks.length,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.shift_management}
            accessCode={accessCodes.shift_scheduling}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                onClick={() => handleEditClick(record)}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
          {/* <Can
            accessModule={accessCodes.shift_management}
            accessCode={accessCodes.shift_scheduling}
            accessType="haveDelete"
          >
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Delete</Tooltip>}
          >
            <Link className="me-2 p-2" to="#">
              <Popconfirm
                title="Are you sure to Delete?"
                onConfirm={() => deleteItemHandler(record.code)}
              >
                <Trash2 className="feather-delete" />
              </Popconfirm>
            </Link>
          </OverlayTrigger>
          </Can> */}
        </div>
      ),
    },
  ];
  if (isLoading) return <LoadingSpinner />;
  // if (isError) return <Error404 error={error} />;
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Shift Rotation</h4>
            <h6>Manage Company Shift Rotation</h6>
          </div>
          <div className="page-btn" style={{ display: "flex" }}>
            <Can
              accessModule={accessCodes.shift_management}
              accessCode={accessCodes.shift_scheduling}
              accessType="haveAdd"
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">New Rotation</Tooltip>}
              >
                <Link to="#" className="btn btn-added" onClick={handleAddClick}>
                  <PlusCircle className="me-2" />
                  Add
                </Link>
              </OverlayTrigger>
            </Can>
            {/* <>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="add-new-tooltip">Add New Shift Policy</Tooltip>
                  }
                >
                  <Link
                    to={`${all_routes.shift}${all_routes.shift_policy}${all_routes.add_shift_policy}`}
                    className="btn btn-added"
                  >
                    
                    <PlusCircle className="me-2" />
                    Add
                  </Link>
                </OverlayTrigger>
                &nbsp;
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="back">Back</Tooltip>}
                >
                  <Link
                    to={`${all_routes.master}`}
                    className="btn btn-added btn-secondary"
                  >
                    <ArrowLeft className="me-2" />
                    Back
                  </Link>
                </OverlayTrigger>
              </> */}
          </div>
        </div>

        <div className="card border-0">
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={shiftRotationData} />
            </div>
          </div>
        </div>
      </div>
      <FormProvider {...methods}>
        <ShiftRotationModal
          mode={selectedItem ? "E" : "I"}
          onSubmit={onSubmit}
          show={show}
          handleClose={handleClose}
          groupData={groups}
          shiftData={shift}
        />
      </FormProvider>
    </div>
  );
};

export default ShiftRotation;
